import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, Platform, ToastController, ModalController } from '@ionic/angular';
//import { Contacts, Contact, ContactField, ContactName } from '@awesome-cordova-plugins/contacts/ngx';
import { Client } from '../../models/client/client.model';
import { ClientService } from '../../services/client.service';
import { UserService } from '../../services/user.service';
import { fromJS, List } from 'immutable';

import { OnBoardingService } from '../../services/on-boarding.service';
import { Utilities } from '../../utilities/utilities';
import { Router, ActivatedRoute } from '@angular/router';
// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics';
import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';
declare var posthog: any;
@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.page.html',
  styleUrls: ['./contact-list.page.scss'],
})
export class ContactListPage implements OnInit {

  public isLoading: boolean;

  public contactList: List<any>;

  public modal: boolean;

  constructor (//private navParams: NavParams,
              //private navController: NavController,
              private clientService: ClientService,
              private modalCtrl: ModalController,
              //private contacts: Contacts,
              private onBoardingService: OnBoardingService,
              private alertController: AlertController,
              private toastController: ToastController,
              public platform: Platform,
              // private googleAnalytics: GoogleAnalytics,
              private userService: UserService,
              private readonly alertService: AlertService,
              private readonly toastService: ToastService,
              private router: Router,
              private loadingCtrl: LoadingController,
              private route: ActivatedRoute) {
    this.isLoading = true;
    //this.modal = this.navParams.get('modal');
    this.modal = route.snapshot.params.modal;
    this.contactList = List([]);
  }

 

  public ngOnInit () {

   this.onBoardingService.getStylistOnBoarding()
    .subscribe((stylistOnboarding) => {

      if (this.onBoardingService.isImportClientsOnboardingDone()) {
        return;
      }

      stylistOnboarding = stylistOnboarding.setImportClients(1);
      this.onBoardingService.save(stylistOnboarding)
        .subscribe((onboarding) => {});
    });

   /* this.contacts.find(["displayName", "name"], {multiple: true})
      .then((contacts) => {
        this.contactList = fromJS(contacts);
        this.isLoading = false;*/

        // ajax 

        // processing
     /* })
      .catch((err) => {
        this.isLoading = false;
      });*/

    // this.googleAnalytics.trackView('ContactListPage')
    //   .then(() => {
    //   })
    //   .catch(() => {
    //   });
  }

  public async onClientImport (contact: any) {

    if (!this.userService.isLoggedIn()) {
      return;
    }

    let client = new Client();
    client = client.setStylistID(this.userService.getUser().getID());

    if (contact.name.givenName) {
      client = client.setFirstName(contact.name.givenName);
    }

    if (contact.name.familyName) {
      client = client.setLastName(contact.name.familyName);
    }

    if (contact.phoneNumbers && contact.phoneNumbers.length >= 1) {
      client = client.setPhone2(contact.phoneNumbers[0].value);
    }

    if (contact.emails && contact.emails.length >= 1) {
      client = client.setEmail(contact.emails[0].value);
    }

    client = client.setSalonID(this.userService.getSalon().id);

    const loader = await this.loadingCtrl.create({
      spinner: 'crescent',
    });

    loader.present();
    this.clientService.saveClient(client)
      .subscribe({
          next:(client: Client) => {
            loader.dismiss().then(() => {
              this.toastService.presentSimpleToast(`Client has been imported`, 3000);
              //this.toastController.create({ message: `Client has been imported`, showCloseButton: true, position: 'bottom' }).present();
            });
          },
          error: (e) => {
            loader.dismiss().then(() => {
              this.alertService.presentErrorAlert();
            });
          }
      });
  }

  public onDismiss () {
    this.modalCtrl.dismiss();
  }

}
